module.exports = __webpack_public_path__ + "be9c1bc96d748aefd6302d00ea7d2391.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/fiserv_2022_chart.png
// module id = 1679
// module chunks = 0